import { GEOZONES } from '../geography/geozones';

export function createGeozoneLayer(maps, map) {
  const layer = new maps.Data({ map });
  // Data retains every MultiPolygon part and hole; there is no viewport change.
  layer.addGeoJson(GEOZONES);
  return layer;
}

export function styleGeozoneLayer(layer, { zoneId, visible, color }) {
  layer.setStyle(feature => {
    const selected = feature.getId() === zoneId;
    return {
      visible,
      clickable: false,
      strokeColor: color,
      strokeOpacity: selected ? 1 : 0.65,
      strokeWeight: selected ? 3 : 1,
      fillColor: color,
      fillOpacity: selected ? 0.18 : 0.025,
      zIndex: selected ? 2 : 1,
    };
  });
}
